<template>
  <div class="step-container scrollPosition error-page">
    <div class="text-center my-5">
      <img
        class="mb-3"
        :src="require('@/assets/icons/Svgs/Gruppe_8835_dark_outline.svg')"
        alt=""
      />
      <h1 class="mb-3 error-title">Ein Fehler ist aufgetreten.</h1>
      <p class="mb-3 error-text">Bitte versuchen Sie es in Kürze erneut.</p>
      <button
        class="next-btn"
        @click="goToStart()"
      >
        Seite neu laden
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "wohnung-step-11c",
  methods: {
    goToStart() {
      this.$router.push("/start");
    },
  },
  mounted() {
    this.$emit("setStep", "wohnung", 13);
    document.getElementById('price-indicator').scrollIntoView({behavior: 'smooth'});
  },
};
</script>
